import React, { useEffect, useState } from 'react';
import './WhatsAppCarousel.scss';

// Import WhatsApp icon assets
import carousel1 from '../../assets/WhatsApp/whatsapp-carousel-1.svg';
import carousel2 from '../../assets/WhatsApp/whatsapp-carousel-2.svg';
import carousel3 from '../../assets/WhatsApp/whatsapp-carousel-3.svg';

const carouselItems = [
    {
        id: 1,
        title: 'WhatsApp Broadcasting',
        description: 'Send transactional updates, OTPs, and marketing messages at scale. Easily manage and customize templates on our platform.',
        icon: 'whatsapp',
    },
    {
        id: 2,
        title: 'Business Account Setup',
        description: 'Easily set up and manage your WhatsApp Business account.',
        icon: 'business',
    },
    {
        id: 3,
        title: 'API & Integration',
        description: 'Directly integrate WhatsApp Cloud API for secure and scalable messaging.',
        icon: 'api',
    },
];

const WhatsAppCarousel = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    // Auto-rotate carousel every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const renderIcon = (iconType) => {
        switch (iconType) {
            case 'whatsapp':
                return (
                    <div className="whatsapp-icon">
                        <img src={carousel1} alt="WhatsApp Broadcasting" />
                    </div>
                );
            case 'business':
                return (
                    <div className="business-icon">
                        <img src={carousel2} alt="Business Account Setup" />
                    </div>
                );
            case 'api':
                return (
                    <div className="api-icon">
                        <img src={carousel3} alt="API & Integration" />
                    </div>
                );
            default:
                return null;
        }
    };

    const handleIndicatorClick = (index) => {
        setActiveIndex(index);
    };

    const activeItem = carouselItems[activeIndex];

    return (
        <div className="whatsapp-carousel">
            <div className="carousel-icon">
                {renderIcon(activeItem.icon)}
            </div>
            <div className="carousel-content">
                <h4>{activeItem.title}</h4>
                <p>{activeItem.description}</p>
            </div>
            <div className="indicators">
                {carouselItems.map((item, index) => (
                    <button
                        key={item.id}
                        className={`indicator ${index === activeIndex ? 'active' : ''}`}
                        onClick={() => handleIndicatorClick(index)}
                        aria-label={`View ${item.title}`}
                        type="button"
                        tabIndex="-1"
                    />
                ))}
            </div>
        </div>
    );
};

export default WhatsAppCarousel; 